module.exports = __webpack_public_path__ + "home-block-6-image@2x-35IBU9U.jpg";